var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoMinner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 133.612,
    height: 30,
    viewBox: "0 0 133.612 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.009 56.233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.008-53.514V-50.8h5.034v-5.437H70.008Z",
    transform: "translate(-32.655 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.383-40.777a9.24,9.24,0,0,0-4.46,2.4l-.725.675v-2.738h-5.437V-19.7H233.2v-13.7l.493-.483a7.981,7.981,0,0,1,2.829-1.54,5.754,5.754,0,0,1,2.044-.232h1.279v-5.286l-.373.01A6.287,6.287,0,0,0,238.383-40.777Z",
    transform: "translate(-106.24 -7.13)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.745-40.618a9.929,9.929,0,0,0-4.853,2.436l-.534.5v-2.547H89.821v20.74h5.537v-14.1l.544-.534a5.9,5.9,0,0,1,3.745-1.742,3.789,3.789,0,0,1,3.564,1.359c.584.916.6,1.188.6,8.437v6.574h5.447l-.03-8.236-.03-8.226-.312-.856a5.321,5.321,0,0,0-3.715-3.594,6.524,6.524,0,0,0-2.366-.292A15.131,15.131,0,0,0,100.745-40.618Z",
    transform: "translate(-41.898 -7.248)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.981-40.551a9.38,9.38,0,0,0-4.37,2.255l-.745.695v-2.638H136.43V-19.5h5.437V-33.524l.685-.664a5.755,5.755,0,0,1,4.752-1.651,3.06,3.06,0,0,1,3.02,2.97c.05.4.1,3.574.1,7.048V-19.5h5.447l-.03-8.125c-.03-7.38-.05-8.2-.211-8.739a5.6,5.6,0,0,0-3.947-4.078A12.4,12.4,0,0,0,146.981-40.551Z",
    transform: "translate(-63.639 -7.235)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.1-40.593a10.423,10.423,0,0,0-8.125,7.209,11.823,11.823,0,0,0,1.007,9.4,11.927,11.927,0,0,0,2.718,2.94c3.222,2.3,7.984,2.7,12.283,1.037a11.711,11.711,0,0,0,2.95-1.742c.111-.131-.05-.413-1.047-1.873-.644-.936-1.2-1.712-1.228-1.712a3.742,3.742,0,0,0-.534.352,10.022,10.022,0,0,1-3.081,1.369,8.68,8.68,0,0,1-3.665.05,5.5,5.5,0,0,1-4.168-4.319l-.06-.272h15.434l-.06-1.691a11.2,11.2,0,0,0-3.282-8.175,9.485,9.485,0,0,0-4.329-2.426A16.328,16.328,0,0,0,189.1-40.593Zm3.937,4.49a4.58,4.58,0,0,1,3.02,3.212,3.831,3.831,0,0,1,.161.785v.232h-10.1l.06-.453a5.915,5.915,0,0,1,.413-1.208,4.9,4.9,0,0,1,3.312-2.728A7.124,7.124,0,0,1,193.041-36.1Z",
    transform: "translate(-84.166 -7.243)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.672-40.409a10.364,10.364,0,0,0-4.2,2.044l-.483.423L5.94-39.03l-.05-1.077-2.94-.03L0-40.158v12.283l2.95-.02,2.94-.03.03-2.94.02-2.94.574-.5a5.084,5.084,0,0,1,3.947-1.329,2.551,2.551,0,0,1,2.144,1.571l.232.5.03,7.118.03,7.128h5.527V-33.4l.654-.654c1.832-1.832,4.762-2.175,5.98-.695.685.826.654.534.695,8.356l.03,7.078h5.537l-.04-8.236c-.03-7.41-.05-8.286-.2-8.87-.715-2.638-2.487-3.987-5.417-4.118a8.586,8.586,0,0,0-5.326,1.5A8.771,8.771,0,0,0,18.122-36.9c0,.06-.161-.221-.352-.624a5.126,5.126,0,0,0-3.151-2.708A9.479,9.479,0,0,0,10.672-40.409Z",
    transform: "translate(0 -7.316)",
    stroke: "red",
    strokeWidth: 0.019
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.442-29.446v10.37h5.537v-20.74H69.442Z",
    transform: "translate(-32.391 -7.658)",
    stroke: "red",
    strokeWidth: 0.019
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-7.3v2.517H5.94V-9.812H0Z",
    transform: "translate(0 -21.653)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMinner);
export default __webpack_public_path__ + "static/media/logo_minner.2a08b0567d74ccc01855e0f46ceaa322.svg";
export { ForwardRef as ReactComponent };